import { defineStore } from "pinia";
import {
  API_Patient_info,
  patientInfoKeys,
  RawPatientInfoType,
} from "@/services/api/Patient/info";
import { useAuthStateStore } from "@/store/authData";
import {
  API_Contract_patient_list,
  PatientListItem,
} from "@/services/api/Contract/patient_list";
import {API_Contract_patient_list_sig, PatientListSigItem} from "@/services/api/Contract/patient_list_sig";

export interface IUserDataStore extends RawPatientInfoType {
  documentList: PatientListItem[];
  documentListSig: PatientListSigItem[];
  documentListLoading: boolean;
  documentListSigLoading: boolean;
}

function createEmptyStorage(): IUserDataStore {
  return {
    num: 0,
    lastname: "",
    firstname: "",
    secondname: "",
    birthdatestr: "",
    phone: "",
    cellular: "",
    email: "",
    snils: "",
    address_proj: "",
    count_login: 0,
    documentList: [],
    documentListSig: [],
    documentListLoading: false,
    documentListSigLoading: false,
  };
}

export const useUserDataStore = defineStore({
  id: "userData",
  state: (): IUserDataStore => {
    //return makeObjectFromKeyArray(patientInfoKeys);
    return createEmptyStorage();
  },
  getters: {
    fullName: ({ lastname, firstname, secondname }) =>
      `${lastname} ${firstname} ${secondname}`,
    userFirstName: ({ firstname }) => `${firstname}`,
    documents: ({ documentList }) => documentList,
    documentsLoading: ({ documentListLoading }) => documentListLoading,
    documentsSig: ({ documentListSig }) => documentListSig,
  },
  actions: {
    getUserData() {
      const authStateStore = useAuthStateStore();

      return new Promise<void>((resolve, reject) => {
        API_Patient_info()
          .then((userData) => {
            this.setFrom(userData);
            if (typeof this.phone === "string")
              this.phone = this.phone.replace(/[() \s]/g, "");

            authStateStore.userAuthenticated = true;
            resolve();
          })
          .catch((err) => {
            reject(err);
            authStateStore.userAuthenticated = false;
          });
      });
    },

    getCopy(): IUserDataStore {
      return patientInfoKeys.reduce((acc, key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        acc[key] = this[key];
        return acc;
      }, createEmptyStorage());
    },

    setFrom(from: RawPatientInfoType) {
      patientInfoKeys.forEach((key) => {
        if (from[key] !== undefined && this[key] !== undefined) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this[key] = from[key];
        }
      });
    },

    loadDocuments() {
      if (this.documentListLoading) return;
      this.documentListLoading = true;
      API_Contract_patient_list()
          .then((contractList) => {
            this.documentList = contractList;
            this.documentListLoading = false;
          })
          .catch(e => {
            console.error(e);
            this.documentListLoading = false;
          })

    },

    loadDocumentsSig() {
      if (this.documentListSigLoading) return;
      this.documentListSigLoading = true;
      API_Contract_patient_list_sig().then((contractListSig) => {
        this.documentListSig = contractListSig;
      });
      this.documentListSigLoading = false;
    },
  },
});
